/**
 * The three type settings a Today card is made of. One string each, so the
 * cards cannot drift apart a tracking value at a time: before this, the page
 * carried nine eyebrow settings and five body sizes for what reads as one
 * surface. Colour is the caller's, because it depends on the ground the card
 * sits on.
 */

/**
 * The card eyebrow: small sentence-case sans at medium weight. "Keeping an eye
 * on". Mono is kept for data (times, counts, units), so a label never reads as
 * a readout.
 */
export const CARD_EYEBROW = "font-sans font-medium text-xs";

/** Body copy: the Heartbeat timeline's setting. A reading, a reason, a detail. */
export const CARD_BODY = "font-sans text-sm font-normal leading-snug";

/** A row's title inside a card: the sense card's "move" line. */
export const CARD_ROW_TITLE = "font-sans text-base font-medium leading-snug";
